import React, { FC } from 'react';

import Picture from 'components/picture';

import { ButtonContainer, Label } from './header-button.styled';
import { IHeaderButtonProps } from './types';

/**
 *
 * Component that allows the user to select which menu he is seeing
 *
 */
const HeaderButton: FC<IHeaderButtonProps> = ({
  label,
  image,
  icon,
  as,
  to,
  $displayRoundBorders = true,
  ...containerProps
}) =>
  !image && !icon ? null : (
    <ButtonContainer
      {...containerProps}
      $displayRoundBorders={$displayRoundBorders}
      as={as}
      to={to}
    >
      {image && <Picture image={image} alt="" objectFitContain={true} aria-hidden />}
      {icon}
      <Label>{label}</Label>
    </ButtonContainer>
  );

export default HeaderButton;
